<template>
  <KartePlannerCommentMonthlyAmountCounter
    v-if="props.amount"
    :usage="props.amount.usage"
    :upperLimit="props.amount.upperLimit ?? undefined"
  />
</template>

<script setup lang="ts">
import KartePlannerCommentMonthlyAmountCounter from './KartePlannerCommentMonthlyAmountCounter.vue'
import type { V2022_1KartePlannerCommentMonthlyAmountFragment } from './KartePlannerCommentMonthlyAmountV20221.generated'

const props = defineProps<{
  amount: Maybe<V2022_1KartePlannerCommentMonthlyAmountFragment>
}>()
</script>
